<template>
  <v-container class="asset-overview-container">
    <v-row no-gutters>
      <v-col cols="12" md="1">
        <router-link
          :to="{ name: 'OverviewPage', hash: '#your-assets' }"
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>

      <v-col cols="12" md="4" class="form-blurb">
        <h1 class="mb-2">Your assets</h1>
        <p>Tell us about your assets:</p>
        <ul class="mt-2 mb-4">
          <li>
            Here you need to add all assets that you want to explicitly donate
            to specific people and/or charities that won’t be catered for as
            part of the remainder of your estate.
          </li>
          <li>
            Listing all your assets will also ensure that your Executor is fully
            informed which will avoid unncessary delays in winding up your
            estate.
          </li>
        </ul>
      </v-col>

      <v-col v-if="loading" cols="12" md="5" offset-md="1" class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </v-col>

      <v-col v-else cols="12" md="7" class="mt-4">
        <div class="left-section-container">
          <h3>Do you want this will to apply to your world wide assets?</h3>

          <ValidationObserver ref="observer">
            <ValidationProvider
              id="world-wide-assets"
              v-slot="{ errors }"
              name="world-wide-assets"
              rules="required"
            >
              <!-- <v-radio-group
                v-if="!whitelabel.omDesign"
                v-model="testator.worldWideAssets"
                row
                :error-messages="errors"
              >
                <div class="world-wide-choice">
                  <v-radio
                    label="Yes, world wide assets"
                    :value="true"
                    color="white"
                    active-class="primary-highlighted"
                    @click="
                      sendGADataLayer('your-assets-world-wide-assets-yes')
                    "
                  />
                  <ul>
                    <li>
                      You will be cancelling all existing wills you may have in
                      any country
                    </li>
                    <li>
                      You can make provision for all assets you own, anywhere in
                      the world, in this will
                    </li>
                  </ul>
                </div>

                <div v-if="testator.worldWideAssets">
                  <p class="warning-text px-4">
                    Take note: If you own assets other than cash outside
                    {{ willCountry }}, it is advisable that you seek
                    personalised professional advice on drafting a will
                    specifically for the country where those assets are based.
                    In the absence of having a seperate will for assets in
                    another country, it is still better to have this will in
                    place, rather than no will at all.
                  </p>
                </div>
                <div class="world-wide-choice">
                  <v-radio
                    :label="localAssetsCheckboxLabel"
                    :value="false"
                    color="white"
                    active-class="primary-highlighted"
                    @click="sendGADataLayer('your-assets-world-wide-assets-no')"
                  />
                  <ul>
                    <li>
                      You can not make provision for assets situated outside
                      {{ willCountry }} in this will
                    </li>
                    <li>If you have a foreign will, it will remain in force</li>
                    <li>
                      If you do not have a will for your foreign assets, those
                      assets will be administered in terms of the intestate
                      succession laws of of the country those assets are
                      situated in.
                    </li>
                  </ul>
                </div>
              </v-radio-group> -->
              <v-radio-group
                v-model="testator.worldWideAssets"
                row
                :error-messages="errors"
              >
                <div class="world-wide-choice">
                  <RadioSelect
                    v-model="testator.worldWideAssets"
                    :items="[{ value: true, text: 'Yes, world wide assets' }]"
                    :group="'worldWideAssets'"
                    :color="'white'"
                    :active-class="'primary-highlighted'"
                    :errors="errors"
                    :className="'world-wide-choice'"
                  />
                  <ul>
                    <li>
                      You will be cancelling all existing wills you may have in
                      any country
                    </li>
                    <li>
                      You can make provision for all assets you own, anywhere in
                      the world, in this will
                    </li>
                  </ul>
                </div>

                <div v-if="testator.worldWideAssets">
                  <p class="warning-text px-4">
                    Take note: If you own assets other than cash outside
                    {{ willCountry }}, it is advisable that you seek
                    personalised professional advice on drafting a will
                    specifically for the country where those assets are based.
                    In the absence of having a seperate will for assets in
                    another country, it is still better to have this will in
                    place, rather than no will at all.
                  </p>
                </div>
                <div class="world-wide-choice">
                  <RadioSelect
                    v-model="testator.worldWideAssets"
                    :items="[{ value: false, text: localAssetsCheckboxLabel }]"
                    :group="'worldWideAssets'"
                    :color="'white'"
                    :active-class="'primary-highlighted'"
                    :className="'world-wide-choice'"
                    :errors="errors"
                  />
                  <ul>
                    <li>
                      You can not make provision for assets situated outside
                      {{ willCountry }} in this will
                    </li>
                    <li>If you have a foreign will, it will remain in force</li>
                    <li>
                      If you do not have a will for your foreign assets, those
                      assets will be administered in terms of the intestate
                      succession laws of of the country those assets are
                      situated in.
                    </li>
                  </ul>
                </div>
              </v-radio-group>
            </ValidationProvider>
          </ValidationObserver>
          <GradientButton
            :title="'Next'"
            :small="true"
            :callout="'right'"
            :loading="buttonLoading"
            @gradientButtonClicked="saveAndContinue"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {
    UPDATE_TESTATOR_MUTATION,
    TESTATOR_QUERY,
  } from '../../constants/graphql/testators';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'WorldWideAssets',
    mixins: [formHelperMixin],
    data() {
      return {
        testator: {},
        loading: true,
      };
    },
    computed: {
      willCountry() {
        return this.testator.willCountry == 'ZA'
          ? 'South Africa'
          : 'the United Kingdom';
      },
      localAssetsCheckboxLabel() {
        if (this.testator.willCountry == 'ZA') {
          return 'No, only South African assets';
        } else {
          return 'No, only the United Kingdom assets';
        }
      },
    },
    methods: {
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
      saveAndContinue() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.updateTestator();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updateTestator() {
        this.buttonLoading = true;
        const testatorInputDetails = {
          worldWideAssets: this.testator.worldWideAssets,
        };
        const id = this.testatorId;

        return this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(_result => {
            this.redirectToNext();
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      redirectToNext() {
        this.$router.push({ name: 'AssetsOverview' });
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data) {
            this.loading = false;
          }
        },
      },
    },
  };
</script>

<style scoped lang="scss">
  .asset-overview-container {
    margin-bottom: 60px;
    .left-section-container {
      padding-left: 121px;
    }
  }

  .world-wide-choice {
    // border in global.scss because of IE issue
    border-radius: 0px;
    margin: 10px;
    padding: 15px;
    width: 100%;

    .v-radio {
      // border in global.scss because of IE issue
      border-radius: 6px;
      font-weight: bold;
      margin-right: 0;
      margin-bottom: 5px;
      padding: 15px;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .asset-overview-container {
      .left-section-container {
        padding-left: 0;
      }
    }
  }
</style>
